import { render, staticRenderFns } from "./MessageInputField.vue?vue&type=template&id=05011367&scoped=true&"
import script from "./MessageInputField.vue?vue&type=script&lang=js&"
export * from "./MessageInputField.vue?vue&type=script&lang=js&"
import style0 from "./MessageInputField.vue?vue&type=style&index=0&id=05011367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05011367",
  null
  
)

export default component.exports